import { useEffect } from "react";
import { Undo2, Redo2, CloudCheck, Loader2, CircleDot } from "lucide-react";
import { Button } from "@/components/ui/button";

const typing = (el) => el && el.isContentEditable;

export const HistoryBar = ({ hist, status }) => {
  const { undo, redo, canUndo, canRedo } = hist;
  useEffect(() => {
    const onKey = (e) => {
      if (!(e.ctrlKey || e.metaKey) || typing(document.activeElement)) return;
      const k = e.key.toLowerCase();
      if (k === "z" && !e.shiftKey) { e.preventDefault(); undo(); }
      else if (k === "y" || (k === "z" && e.shiftKey)) { e.preventDefault(); redo(); }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [undo, redo]);

  return (
    <div className="ml-auto flex items-center gap-2" data-testid="history-bar">
      <span className="flex items-center gap-1.5 text-xs text-slate-400 mr-2" data-testid="autosave-status">
        {status.saving ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : status.dirty ? <CircleDot className="h-3.5 w-3.5 text-amber-400" /> : <CloudCheck className="h-3.5 w-3.5 text-emerald-400" />}
        <span className="hidden sm:inline">{status.saving ? "Salvataggio…" : status.dirty ? "Modifiche non salvate" : status.at ? `Salvato alle ${status.at}` : "Nessuna modifica"}</span>
      </span>
      <Button variant="outline" size="sm" onClick={undo} disabled={!canUndo} title="Annulla (Ctrl+Z)" data-testid="undo-btn">
        <Undo2 className="h-4 w-4 sm:mr-1" /><span className="hidden sm:inline">Annulla</span>
        {canUndo > 0 && <span className="ml-1 font-mono text-xs text-slate-400" data-testid="undo-count">{canUndo}</span>}
      </Button>
      <Button variant="outline" size="sm" onClick={redo} disabled={!canRedo} title="Ripristina (Ctrl+Y)" data-testid="redo-btn">
        <Redo2 className="h-4 w-4 sm:mr-1" /><span className="hidden sm:inline">Ripristina</span>
      </Button>
    </div>
  );
};
